import { defineComponent as _defineComponent } from 'vue'
import FrkAlert from '@freelancerepublik/commons/ui/components/FrkAlert.vue';
import FrkServerErrorLayout from '../layouts/FrkServerErrorLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FrkServerError',
  props: {
    code: null,
    message: null,
    navbar: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,FrkAlert, FrkServerErrorLayout }
}

})